import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMagnifyingGlass, faX } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-item-search',
  imports: [FontAwesomeModule],
  templateUrl: './item-search.component.html',
  styleUrl: './item-search.component.scss'
})


export class ItemSearchComponent {

  @Input() searchQuery?: string;
  @Input() categoryName?: string;

  faMagnifyingGlass = faMagnifyingGlass;
  faX = faX;

}
